import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import PropTypes from "prop-types"

import {hangPromise} from "@irati/utils/promise"
import perksSettingsService from "@irati/deals/services/perksSettings"
import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {ShadowCard} from "@irati/ui/src/Layout"
import {H2} from "@irati/ui/src/Typography"
import {Para} from "@irati/ui/src/Labels"
import Form from "@irati/ui/src/Form"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import {Checkbox} from "@irati/ui/src/FormItem"
import BenefitsSchemeName from "@irati-web/fields/companyBenefits/BenefitsSchemeName"
import Modal from "@irati/ui/src/Modal"

import {SETTINGS_CUSTOMISE_BENEFITS} from "../../../routes/routeConfig"
import UploadImage from "./UploadImage"
import UploadedImage from "./UploadedImage"
import {ButtonWrapper, StyledSuccess, StyledError} from "./styled"

const minImageDimensions = {width: 240, height: 240}

class CompanyBenefitsSettings extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      load: hangPromise(),
      data: {},
      name: "",
      logoUrl: null,
      submit: null,
      topOfHomepage: false,
      showSuccessModal: false
    }
  }

  componentDidMount() {
    this.setState({load: this.getSettings()})
  }

  getSettings = () => {
    const {formatMessage} = this.props
    const {uuid, public_name} = authentication.userTenant()
    const fallbackName = formatMessage({id: "admin.companyBenefits.settings.name.defaultText"}, {tenantName: public_name})

    return perksSettingsService.get(uuid).then((settings) => {
      const name = settings.companyBenefits.name || fallbackName
      const logoUrl = settings.companyBenefits.logoUrl || null
      const topOfHomepage = settings.companyBenefits.topOfHomepage || false

      this.setState({data: settings, name, logoUrl, topOfHomepage})
    })
  }

  handleChangeName = (name) => this.setState({name})

  handleChangeTopOfHomepage = () => this.setState((prevState) => ({topOfHomepage: !prevState.topOfHomepage}))

  handleAddImage = (logoUrl) => this.setState({logoUrl})

  handleDeleteImage = () => this.setState({logoUrl: null})

  showSuccessModal = () => this.setState({showSuccessModal: true})

  hideSuccessModal = () => this.setState({showSuccessModal: false})

  handleSuccess = () => {
    this.showSuccessModal()
    setTimeout(this.hideSuccessModal, 2000)
  }

  handleSave = () => {
    const {data, name, logoUrl, topOfHomepage} = this.state
    const editedSettings = {...data.companyBenefits, name, logoUrl, topOfHomepage}

    const submit = perksSettingsService
      .update(authentication.userTenant().uuid, {companyBenefits: editedSettings})
      .then((updatedSettings) => {
        this.handleSuccess()
        this.setState({data: updatedSettings})
      })

    this.setState({submit})
    return submit
  }

  render() {
    const {formatMessage} = this.props
    const {load, name, logoUrl, submit, showSuccessModal, topOfHomepage} = this.state

    return (
      <>
        <ShadowCard large linkProps={{to: SETTINGS_CUSTOMISE_BENEFITS}}>
          <H2 marginBottom={4}>
            <FormattedMessage id="admin.companyBenefits.settings.title" />
          </H2>
          <Loading load={load}>
            <Row>
              <Col md={12}>
                <Form>
                  <BenefitsSchemeName
                    required
                    label={formatMessage({id: "admin.companyBenefits.settings.name.label"})}
                    onChange={this.handleChangeName}
                    value={name} />
                  <Para>
                    <FormattedMessage id="admin.companyBenefits.settings.logo.label" />
                  </Para>
                  <UploadedImage image={logoUrl} onDelete={this.handleDeleteImage} />
                  <UploadImage minDimensions={minImageDimensions} onChange={this.handleAddImage} />
                  <Checkbox checked={topOfHomepage} name="topOfHomePage" onChange={this.handleChangeTopOfHomepage}>
                    <FormattedMessage id="admin.companyBenefits.settings.topOfHomePage.label" />
                  </Checkbox>
                </Form>
                <ButtonWrapper>
                  <ValidationButton load={submit} primary onClick={this.handleSave}>
                    <FormattedMessage id="admin.companyBenefits.settings.save" />
                  </ValidationButton>
                </ButtonWrapper>
                <StyledError>
                  <Loading load={submit} useLoader={false} />
                </StyledError>
              </Col>
            </Row>
          </Loading>
        </ShadowCard>
        <Modal show={showSuccessModal} onHide={this.hideSuccessModal}>
          <StyledSuccess message={formatMessage({id: "admin.companyBenefits.settings.updateSuccessful"})} />
        </Modal>
      </>
    )
  }
}

export default injectIntl(CompanyBenefitsSettings)
